export const truncateEmail = (email: string, maxLength: number = 30): string => {
  if (email.length <= maxLength) {
    return email;
  }

  const [localPart, domain] = email.split("@");
  if (!domain) {
    return email;
  }

  // Calculate how much space we have for the local part
  // Reserve space for "...@" and the domain
  const domainWithAt = `@${domain}`;
  const availableLength = maxLength - domainWithAt.length - 2; // 2 for ".."

  if (availableLength < 3) {
    // If domain is too long, just show beginning and end of email
    const keepChars = Math.floor((maxLength - 2) / 2);
    return `${email.substring(0, keepChars)}..${email.substring(
      email.length - keepChars
    )}`;
  }

  // Truncate local part and keep full domain
  return `${localPart.substring(0, availableLength)}..${domainWithAt}`;
};
